<div class="alerts position-fixed mt-3 right w-50">
  <ng-container *ngFor="let alert of alerts">
      <ngb-alert [type]="alert.type" (close)="removeAlert(alert)">
          {{alert.message}}
        </ngb-alert>
  </ng-container>
</div>
